import { useEffect, useState } from 'react'

import { useTranslations } from 'next-intl'
import { useRouter } from 'next/router'

import { Hamburger } from '@/components/Icons'

import Actions from './Actions'
import Footer from './Footer'
import Links from './Links'
import MenuContainer from './MenuContainer'

import styles from './Menu.module.scss'

export type MenuLink = {
  href: string
  label: string
}

type Props = {
  eventLinks?: MenuLink[]
  gameLinks: MenuLink[]
  infoLinks: MenuLink[]
}

export const MobileNav = ({ eventLinks, gameLinks, infoLinks }: Props) => {
  const t = useTranslations()
  const [isOpen, setIsOpen] = useState(false)
  const { events } = useRouter()

  useEffect(() => {
    if (!events) return
    const listener = () => setIsOpen(false)
    events.on('routeChangeComplete', listener)
    return () => events.off('routeChangeComplete', listener)
  }, [events])

  const closeMenu = () => {
    setIsOpen(false)
  }

  return (
    <>
      <button className={styles.MenuButton} onClick={() => setIsOpen(true)} data-cy="mobile-nav-button">
        <Hamburger />
      </button>
      <MenuContainer isOpen={isOpen} closeMenu={closeMenu}>
        {eventLinks?.length ? <Links title="Special Events" links={eventLinks} dataCy="mobile-nav-event-list" /> : null}
        <Links title={t('our_games')} links={gameLinks} dataCy="mobile-nav-game-list" />
        <Links title={t('information')} links={infoLinks} dataCy="mobile-nav-info-list" />
        <Actions closeMenu={closeMenu} />
        <Footer />
      </MenuContainer>
    </>
  )
}
